export function sanitizeTextForComparison(text) {
  return text
    ? text
        .trim()
        .toLowerCase()
        .normalize('NFD') // "á" -> "a"+"'"
        .replace(/[\u0300-\u036f]/g, '') // remove diacritics
        .replace(/[()¡!¿?,.:'"/]/g, ' ')
    : '';
}
